import Home from './components/Home.vue'
import Login from './components/Login.vue'
import Form from './components/Form.vue'
import Report from './components/Report.vue'
import EmailLanding from './components/EmailLanding.vue'
import FormFinal from './components/FormFinal.vue'

export const routes = [
  { path: '/', name: 'homeLink', component: Home },
  { path: '/login', name: 'loginLink', component: Login },
  { path: '/email-landing', name: 'emailLandingLink', component: EmailLanding },
  { path: '/form', name: 'formLink', component: Form, meta: { requiresAuth: true } },
  { path: '/form-final', name: 'formFinalLink', component: FormFinal, meta: { requiresAuth: true } },
  { path: '/report', name: 'reportLink', component: Report, meta: { requiresAuth: true } },
  { path: '*', redirect: '/' }
]


// WEBPACK FOOTER //
// ./src/routes.js